export default __webpack_public_path__ + "static/media/mousai_logo.0ad1fa57.png";